import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { BaseOntarioObstetricalFileSubSection, BaseOntarioObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/Ontario/Subcomponent/BaseOntarioObstetricalFileSubSection";
import { OntarioObstetricalAdditionalInvestigation } from "@/Patient/Models/ObstetricalFile/Ontario/OPR2/OntarioObstetricalAdditionalInvestigation";

class OntarioObstetricalFileAdditionalInvestigationsState {
    public activeTestFieldSelectIndex: number;

    public constructor(fields?: Partial<OntarioObstetricalFileAdditionalInvestigationsState>) {
        Object.assign(this, fields);
    }
}

class OntarioObstetricalFileAdditionalInvestigations extends BaseOntarioObstetricalFileSubSection<BaseOntarioObstetricalFileSubSectionProps, OntarioObstetricalFileAdditionalInvestigationsState> {
    private readonly maxLengthTestField = 23;
    private additionalInvestigationsTestInputs: TextboxControl[] = [];

    public constructor(props: BaseOntarioObstetricalFileSubSectionProps) {
        super(props);
        this.state = new OntarioObstetricalFileAdditionalInvestigationsState({ activeTestFieldSelectIndex: -1 });
    }
    public componentWillMount(): void {
        super.componentWillMount();
    }

    public render(): JSX.Element {
        const additionalInvestigations = this.props.form.Opr2.AdditionalInvestigations;
        const additionalInvestigationsElements: JSX.Element[] = [];
        const numberOfRows = 4;
        for (let index = 0; index < numberOfRows; index++) {
            const indexFirstField = index; // left Side 0, 1, 2, 3
            const indexSecondField = numberOfRows + index; // right side 4,5,6,7
            /* Use of index is not a problem the list is fixed */
            additionalInvestigationsElements.push(
                <div key={"OntarioObstetricalFileAdditionalInvestigations_" + index} className="padding-sm-bottom">
                    <div className="row">
                        {this.renderAdditionalInvestigationField(
                            indexFirstField,
                            additionalInvestigations[indexFirstField]
                        )}
                        {this.renderAdditionalInvestigationField(
                            indexSecondField,
                            additionalInvestigations[indexSecondField]
                        )}
                    </div>
                </div>
            );
        }

        return (
            <div>
                <div className="row">
                    {this.renderAdditionalInvestigationsClickableTexts()}
                </div>
                <div className="row margin-sm-top min-height-additional-investigations">
                    {this.renderTitleOfAddidtionalInvestigationField()}
                    {additionalInvestigationsElements}
                </div>
            </div>
        );
    }

    private renderTitleOfAddidtionalInvestigationField(): JSX.Element {
        return (
            <div className="row">
                <div className="col-md-6">
                    <div className="text-bold col-md-6">{this.getString("TestLabel")}</div>
                    <div className="text-bold col-md-6">{this.getString("ResultLabel")}</div>
                </div>
                <div className="col-md-6">
                    <div className="text-bold col-md-6">{this.getString("TestLabel")}</div>
                    <div className="text-bold col-md-6">{this.getString("ResultLabel")}</div>
                </div>
            </div>
        );
    }

    private renderAdditionalInvestigationField(index: number, test: OntarioObstetricalAdditionalInvestigation): JSX.Element {
        return (
            <div className="col-md-6" id={`AdditionalTest_${index}`}>
                <div className="flex-column col-md-6 ">
                    {this.controlRenderer.renderTextbox(
                        {
                            value: test?.Test,
                            onChange: value => this.onChangeAdditionalTest(index, value),
                            onFocus: () => this.onAdditionalInvestigationFocus(index),
                            onBlur: (event: FocusEvent) => this.onAdditionalInvestigationBlur(event),
                            maxLength: this.maxLengthTestField,
                            className: this.state.activeTestFieldSelectIndex === index ? "active-text-box" : ""
                        },
                        ref => this.additionalInvestigationsTestInputs[index] = ref
                    )}
                </div>
                <div className="flex-column col-md-6">
                    {this.controlRenderer.renderTextbox({
                        value: test?.Result,
                        onChange: value => this.onChangeAdditionalResult(index, value),
                        maxLength: 17
                    })}
                </div>
            </div>
        );
    }

    private renderAdditionalInvestigationsClickableTexts(): JSX.Element {
        return (
            <div className="col-md-12">
                {this.renderClickableText(this.getString("ThyroidStimulationHormoneAbbreviationLabel"))},&nbsp;
                {this.getString("ObstetricalFile_AdditionalInvestigationsDiabetesScreen")} (
                {this.renderClickableText(this.getString("ObstetricalFile_HemoglobinA1CAbbreviation"))},&nbsp;
                {this.renderClickableText(this.getString("ObstetricalFile_RenalBloodFlowAbbreviation"))},&nbsp;
                {this.renderClickableText(this.getString("ObstetricalFile_ForearmBloodFlowAbbreviation"))}
                ),&nbsp;
                {this.renderClickableText(this.getString("ObstetricalFile_HemoglobinElectrophoresisLabel"))},&nbsp;
                {this.renderClickableText(this.getString("ObstetricalFile_FerritinLabel"))},&nbsp;
                {this.renderClickableText(this.getString("ObstetricalFile_B12Label"))},&nbsp;
                {this.getString("ObstetricalFile_InfectiousDiseasesLabel")} (
                {this.renderClickableText(this.getString("ObstetricalFile_HeppatisCAbbreviation"))},&nbsp;
                {this.renderClickableText(this.getString("ParvoB19Label"))},&nbsp;
                {this.renderClickableText(this.getString("VaricellaLabel"))},&nbsp;
                {this.renderClickableText(this.getString("ToxoLabel"))},&nbsp;
                {this.renderClickableText(this.getString("CytomegalovirusLabelAbbreviation"))}
                ),&nbsp;
                {this.renderClickableText(this.getString("ObstetricalFile_DrugScreenLabel"))},&nbsp;
                {this.renderClickableText(this.getString("ObstetricalFile_RepeatSTIScreenLabel"))},&nbsp;
                {this.renderClickableText(this.getString("Covid19Label"))},&nbsp;
                {this.renderClickableText(this.getString("UrineCSLabel"))}
            </div>
        );
    }

    private renderClickableText(text: string): JSX.Element {
        return (
            <span
                key={text}
                tabIndex={0}
                className={this.state.activeTestFieldSelectIndex >= 0 ? "active-clickable-text" : ""}
                onClick={() => {
                    if (this.state.activeTestFieldSelectIndex < 0)
                        return;
                    this.onChangeAdditionalTest(this.state.activeTestFieldSelectIndex, text, true);
                    this.additionalInvestigationsTestInputs[this.state.activeTestFieldSelectIndex].focus();
                }}
            >
                {text}
            </span>
        );
    }

    private onChangeAdditionalTest(index: number, value: string, addText: boolean = false): void {
        this.props.mutateModelState(
            s => s.Opr2.AdditionalInvestigations
                .map((p, i) => {
                    if (i === index && (!addText || !p.Test?.contains(value, { ignoreCase: true, ignoreDiacritics: true })))
                        p.Test = addText
                            ? `${p.Test} ${value}`.trim().substring(0, this.maxLengthTestField)
                            : value;
                })
        );
    }

    private onChangeAdditionalResult(index: number, value: string): void {
        this.props.mutateModelState(
            s => s.Opr2.AdditionalInvestigations
                .map((p, i) => {
                    if (i === index)
                        p.Result = value;
                })
        );
    }

    private onAdditionalInvestigationFocus(index: number): void {
        this.mutateState(s => s.activeTestFieldSelectIndex = index);
    }

    private onAdditionalInvestigationBlur(event: FocusEvent): void {
        if ((event.relatedTarget as any)?.classList?.contains("active-clickable-text"))
            return;
        this.mutateState(s => s.activeTestFieldSelectIndex = -1, () => this.props.handleFormUpdate());
    }
}

export { OntarioObstetricalFileAdditionalInvestigations };
